import { createContext, useContext } from 'react';

// ----------------------------------------------------------------------

export const SnackbarContext = createContext({});

export const useSnackbarContext = () => {
  const context = useContext(SnackbarContext);

  if (!context) throw new Error('useSnackbarContext must be use inside SnackbarProvider');

  return context;
};
